import { useEffect, useState, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import Table from "../../../../../components/tables/tableCols1";
import TableSkeleton from "../../../../../components/skeleton/table";
import TableFilter from "../../../../../components/tables/tableFilter";
import { PaginationNoRoute } from "../../../../../components/pagination/paginationNoRoute";
import EmptyState from "../../../../../assets/images/emptyState/payment.svg";
import { filterShippers } from "../../../../../redux/shippers/shippersActions";

export default function ShipperRevenueSettings() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const currentDate = new Date();
  const [page, setPage] = useState(1);

  const { allShippers, filtering } = useSelector((state) => state.shipper);

  const [payLoad] = useState({
    // API expects Y-m-d H:i
    date: moment(currentDate).format("YYYY-MM-DD HH:mm"),
  });

  useEffect(() => {
    dispatch(filterShippers(payLoad, page));
  }, [dispatch, payLoad, page]);

  function createTableData(data) {
    if (Array.isArray(data)) {
      return data.map((shipper, index) => ({
        single: {
          num: <span className="text-base font-semibold">{index + 1}</span>,
          name: shipper?.shipper_name || shipper?.name,
          email: shipper?.shipper_email || shipper?.email || "N/A",
          location: shipper?.city || "N/A",
          status:
            shipper?.status === "active" ? (
              <span className="text-green-400 font-bold">Active</span>
            ) : (
              <span className="text-gray-400 font-bold">Inactive</span>
            ),
          shipper: shipper,
        },
      }));
    }
    return [];
  }

  const data = useMemo(
    () => createTableData(allShippers?.data),
    [allShippers?.data],
  );

  const goToSettingsPage = (params) => {
    const shipperId = params?.single?.shipper?.id;
    navigate(`/admin/revenue/revenue-settings/shipper/${shipperId}`);
  };

  const columns = useMemo(
    () => [
      {
        Header: "",
        hideHeader: false,
        id: "checkbox-table-column",
        columns: [
          {
            Header: "S/N",
            accessor: "single.num",
          },
          {
            Header: "Shipper Name",
            accessor: "single.name",
          },
          {
            Header: "Email",
            accessor: "single.email",
          },
          {
            Header: "Location",
            accessor: "single.location",
          },
          {
            Header: "Status",
            accessor: "single.status",
          },
        ],
      },
    ],
    [],
  );

  return (
    <div>
      <TableFilter
        title={"Revenue Settings"}
        searchPlaceholder={"Search Shipper name, email, phone number "}
      />

      <div className="border-b border-[#E4E4F3] dark:border-[#505050]"></div>

      {filtering ? (
        <TableSkeleton />
      ) : (
        <div className="bg-white dark:bg-[#121212] rounded-md py-4 px-3">
          {data?.length > 0 ? (
            <Table
              columns={columns}
              data={data}
              onClick={goToSettingsPage}
              goToSinglePage={goToSettingsPage}
            />
          ) : (
            <div className="text-center py-12">
              <img
                src={EmptyState}
                alt="empty"
                className="w-32 h-32 mx-auto mb-4"
              />
              <p className="text-gray-500 dark:text-gray-400">
                No shippers found
              </p>
            </div>
          )}

          <PaginationNoRoute data={allShippers} page={page} setPage={setPage} />
        </div>
      )}
    </div>
  );
}
